<template>
    <TransitionFadeShort v-if="load">
        <MoleculeSkeletonCard />
    </TransitionFadeShort>

    <p class="text-white" v-else-if="artists.length === 0">
        {{ $t('search.artist_empty') }}
    </p>

    <div class="flex" v-else>
        <!-- Artists Grouped by Alphabet -->
        <div class="w-full">
            <div
                v-for="(group, letter, index) in groupedArtists"
                :key="letter"
                class="xl:max-w-[90%] ml-auto"
            >
                <div
                    class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-4 lg:gap-8"
                    :id="letter"
                    :class="{'pt-8': index !== 0}"
                >
                    <h2 class="text-6xl text-white">{{ letter }}</h2>
                    <router-link
                        v-for="artist in group"
                        :to="{name: 'people.view', params: {id: artist.id, slug: artist.slug}}"
                        :key="artist.id"
                        class="bg-black p-4 rounded hover:cursor-pointer hover:opacity-70 transition ease-in-out duration-200"
                    >
                        <div class="flex justify-end">
                            <img
                                loading="lazy"
                                class="w-20 h-24 xl:w-32 xl:h-36 object-cover"
                                :src="artist.cover.cached_url"
                                :alt="artist.name"
                            />
                        </div>
                        <p class="mt-6 lg:mt-10 xl:mt-16 text-white leading-5 xl:text-xl line-clamp-2">
                            {{ artist.name }}
                        </p>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MoleculeSkeletonCard from "../molecules/MoleculeSkeletonCard.vue";
import TransitionFadeShort from "../../../transitions/TransitionFadeShort.vue";

export default {
    name: "OrganismTabArtists",
    components: {TransitionFadeShort, MoleculeSkeletonCard },
    props: {
        artists: null,
        load: false
    },
    computed: {
        groupedArtists() {
            const grouped = {};
            this.artists.forEach((artist) => {
                const lastname = artist.compare.charAt(0).toUpperCase();
                if (!grouped[lastname]) {
                    grouped[lastname] = [];
                }
                grouped[lastname].push(artist);
            });

            const sortedGroups = {};
            Object.keys(grouped)
                .sort()
                .forEach((letter) => {
                    sortedGroups[letter] = grouped[letter];
                });

            return sortedGroups;
        },
    }
};
</script>
